/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { IProperty } from 'entities/Property/Property.models';
import { ICategory } from 'entities/Category/Category.models';

export interface IPropertyContext {
  setFilterIsChanged: (value: boolean) => void;
  selectedCategory: ICategory | null;
  onSelectedCategoryChange: (value: ICategory | null) => void;
  propertiesForView: IProperty[];
  onPropertiesForViewChange: (value: IProperty[]) => void;
  initialFormValues: { [key: string]: any };
}

export const PropertyContext = createContext<IPropertyContext>({
  setFilterIsChanged: () => {},
  selectedCategory: null,
  onSelectedCategoryChange: () => {},
  propertiesForView: [],
  onPropertiesForViewChange: () => {},
  initialFormValues: {},
});
